import { css } from 'emotion'

const isSelected = bool => {
  const backgroundColor = bool ? '#66b2ff' : 'white'
  const color = bool ? 'white' : 'black'
  const borderColor = bool ? '#66b2ff' : '#D5D5D5'
  const zIndex = bool ? '10' : '1'

  return css`
    background: ${backgroundColor};
    color: ${color};
    padding: 5px 0;
    width: 335px;
    font-weight: bold;
    border-bottom: 1px solid ${borderColor};
    cursor: pointer;
    z-index: ${zIndex};
  `
}

export default {
  isSelected,
}
